<script>
import Vue from "vue";
import { mapState } from "vuex";
import SetListMixin from "~~/mixins/SetListMixin.vue";
export default {
  mixins: [SetListMixin],
  data() {
    return {
      groupId: null,
      pGroupId: null,
      mapKey: "catalog/default",
      loading: false,
      timer: null,
    };
  },
  methods: {
    prodMixinInit() {
      this.groupId = parseInt(this.$route.params.groupId);
      if (this.isSubCat) {
        this.pGroupId = parseInt(this.$route.params.pGroupId);
      }
    },
    async fetchProducts() {
      this.loading = true;
      this.prepSetList(this.$config.api.url.newcrm);
      await this.$store.dispatch("fetchProducts", {
        groupId: this.groupId,
      });
      this.loading = false;

      this.$store.dispatch("fetchRel", {
        groupId: this.groupId,
      });
    },
  },
  computed: {
    curProducts() {
      const prod = this.products[this.groupId];
      return (prod && prod.items) || [];
    },
    total() {
      const prod = this.products[this.groupId];
      return (prod && prod.total) || 0;
    },
    catDescription() {
      return this.catDesc[this.groupId] || {};
    },
    category() {
      const forUpdate = this.$route.path;
      this.prodMixinInit();

      return this.isSubCat
        ? (this.cat[this.pGroupId] &&
            this.cat[this.pGroupId].items &&
            this.cat[this.pGroupId].items[this.groupId]) ||
            {}
        : this.cat[this.groupId] || {};
    },
    isSubCat() {
      return this.$route.meta.isSub;
    },
    ...mapState(["cat", "catDesc", "products"]),
  },
};
</script>
